module.exports = __webpack_public_path__ + "img/aileron-focus_NEW.3b400869.png";